module.exports = __webpack_public_path__ + "static/media/email.a6dbba28.svg";